import { useState } from 'react';
import { useLocation } from '@/hooks/useLocation';
import {
  ROUTE_PORTFOLIO_DEMO_RETURNS,
  ROUTE_PORTFOLIO_TRANSACTIONS_CREATE,
} from '@/constants/routes';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';
import { Modal, Button, Heading } from '@simplywallst/ui-core/next';
import { actionToPath } from 'redux-first-router';
import { useCreateTransactionPortfolio } from '@/hooks/portfolio/useCreateTransactionPortfolio';
import { useDispatch } from 'react-redux';

export const TransactionPortfolioUpgrade = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { mutate } = useCreateTransactionPortfolio({
    onSuccess: ({ createTransactionPortfolio }) => {
      const { id } = createTransactionPortfolio;
      dispatch({
        type: ROUTE_PORTFOLIO_TRANSACTIONS_CREATE,
        payload: { portfolioId: id },
      });
    },
  });

  const location = useLocation();
  const demoPath = actionToPath(
    {
      type: ROUTE_PORTFOLIO_DEMO_RETURNS,
      payload: {},
    },
    location.routesMap
  );

  return (
    <>
      <button
        className="w-fit rounded-md bg-warning-subtle px-2 py-[3px] text-tiny text-warning"
        onClick={() => setIsOpen(true)}
      >
        <span>LIMITED DATA</span>
      </button>

      <Modal
        title={
          <Heading as="h2" className="text-lg">
            See your true returns with a Transaction Portfolio
          </Heading>
        }
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="max-h-[800px] max-w-[800px] px-x1 py-x2"
      >
        <div className="-mt-x2 flex flex-col gap-x3 p-x2 pt-0 md:px-x3">
          <p className="m-0 text-sm text-soft">
            Unlock powerful insights by adding your transactions
          </p>
          <ul className="grid items-center gap-x1">
            <li className="flex items-start gap-x1_5">
              <div className="grid items-center rounded-full bg-good-subtle p-x0_5">
                <TickSolid className="size-6 fill-good" />
              </div>
              <div className="flex flex-col">
                <strong className="text-sm text-solid">
                  Detailed Returns Analysis
                </strong>
                <span className="text-sm text-soft">
                  Break down unrealised, realised, dividend, and currency gains
                </span>
              </div>
            </li>
            <li className="flex items-start gap-x1_5">
              <div className="grid items-center rounded-full bg-good-subtle p-x0_5">
                <TickSolid className="size-6 fill-good" />
              </div>
              <div className="flex flex-col">
                <strong className="text-sm text-solid">
                  Annualized Returns
                </strong>
                <span className="text-sm text-soft">
                  Track performance with IRR (Internal Rate of Return)
                </span>
              </div>
            </li>
            <li className="flex items-start gap-x1_5">
              <div className="grid items-center rounded-full bg-good-subtle p-x0_5">
                <TickSolid className="size-6 fill-good" />
              </div>
              <div className="flex flex-col">
                <strong className="text-sm text-solid">
                  Easier Tax & Reporting
                </strong>
                <span className="text-sm text-soft">
                  Export a full transaction report for your records
                </span>
              </div>
            </li>
          </ul>

          <Button onClick={() => mutate({ name: 'Transactions' })}>
            Create Transaction Portfolio
          </Button>
          <Button href={demoPath} variant="secondary">
            Preview Demo Portfolio Returns
          </Button>
        </div>
      </Modal>
    </>
  );
};
